import { Col, Row } from "react-bootstrap";
import type { RangeOption } from "../../../constants/epicLeaderboard";
import type { PkPartner, PkPartners } from "../../../types/playerPk";
import { playerPath } from "../../../utils/playerLink";
import RankedBars from "./RankedBars";
import "./pk.css";

type Props = {
  partners: PkPartners;
  range: RangeOption;
};

const PartnersLists = ({ partners, range }: Props) => {
  const toItems = (list: PkPartner[]) =>
    list.map((p) => ({
      label: p.player,
      count: p.count,
      to: playerPath({ player: p.player, range, tab: "pk" })
    }));

  return (
    <Row className="g-3">
      <Col xs={12} md={6}>
        <div className="pk-card">
          <div className="pk-subtitle">Assisted your kills</div>
          <RankedBars
            items={toItems(partners.assistedBy)}
            emptyText="Nobody assisted your kills in this range."
          />
        </div>
      </Col>
      <Col xs={12} md={6}>
        <div className="pk-card">
          <div className="pk-subtitle">You assisted</div>
          <RankedBars
            items={toItems(partners.assistedFor)}
            color="rgb(174, 217, 224)"
            emptyText="You didn't assist anyone in this range."
          />
        </div>
      </Col>
    </Row>
  );
};

export default PartnersLists;
